// extracted by mini-css-extract-plugin
module.exports = {"iconLoader":"+Y3vN","rotation":"_4vTpl","iconLoader_size_l":"pD1BK","iconLoader_size_xl":"pxgjg"};